import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse, IPriceListPromotion } from '@/_types'

/**
 * Loads a price-list promotion entity by id.
 *
 * @param id - Promotion id.
 */
export const fetchPromotion = async (id: number): Promise<ApiResponse<IPriceListPromotion>> => {
	return axios
		.get<ApiResponse<IPriceListPromotion>>(`v1/web/priceListPromo/priceListPromos/${id}`)
		.then(res => res.data)
}

/**
 * React Query hook for {@link fetchPromotion}; disabled when `id <= 0`.
 *
 * @param id - Promotion id.
 */
export const useGetPromotion = (id: number) => {
	return useQuery<ApiResponse<IPriceListPromotion>>({
		queryKey: ['promotion', id],
		queryFn: () => fetchPromotion(id),
		enabled: id > 0,
		select: data => data
	})
}
